import { jsxs as T, jsx as c } from "react/jsx-runtime";
import { useRef as E, useCallback as L, useEffect as C, forwardRef as j } from "react";
import { L as M } from "../index-D6IbTb4M.js";
import { c as W } from "../clsx-OuTLNxxd.js";
import { B as q } from "../Button-DIvSLTPg.js";
import '../Dialog.css';const P = "_closeButton_ys71q_32", X = "_dialog_ys71q_36", Y = "_hasBackdrop_ys71q_52", $ = "_isFullScreen_ys71q_55", z = "_closeButtonWrapper_ys71q_64", A = "_dialogWrapper_ys71q_77", G = "_panel_ys71q_91", s = {
  closeButton: P,
  dialog: X,
  hasBackdrop: Y,
  isFullScreen: $,
  closeButtonWrapper: z,
  dialogWrapper: A,
  panel: G
}, x = ({
  children: t,
  className: r,
  hasBackdrop: n = !0,
  isFullScreen: N = !1,
  isOpen: e = !1,
  setIsOpen: i,
  shouldCloseOnClickOutside: u = !0,
  title: p,
  triggerRef: a,
  ...b
}) => {
  const l = E(null), d = L(
    (o) => {
      var k, y, g;
      if (!u)
        return;
      const w = (k = l.current) == null ? void 0 : k.getBoundingClientRect(), { bottom: m = 0, left: _ = 0, right: f = 0, top: B = 0 } = w || {};
      if (B === 0 && m === 0 && _ === 0 && f === 0)
        return;
      const D = o.clientY < B || o.clientY > m || o.clientX < _ || o.clientX > f, h = ((y = a == null ? void 0 : a.current) == null ? void 0 : y.isConnected) ?? !1, F = h && ((g = a == null ? void 0 : a.current) == null ? void 0 : g.contains(o == null ? void 0 : o.target)), S = o.target === l.current;
      e && (S || D && !F && h) && i(!1);
    },
    [e, u, i, a]
  );
  return C(() => {
    l.current && (e ? l.current.showModal() : l.current.close());
  }, [l, e]), C(() => {
    if (!(typeof window > "u"))
      return document.addEventListener("click", d), () => {
        document.removeEventListener("click", d);
      };
  }, [d]), /* @__PURE__ */ T(
    "dialog",
    {
      "aria-label": `${p}-modal`,
      className: W(
        s.dialog,
        { [s.hasBackdrop]: n },
        { [s.isFullScreen]: N },
        r
      ),
      "data-cxy-name": "dialog",
      id: "cxy-dialog",
      ref: l,
      ...b,
      children: [
        /* @__PURE__ */ c("div", { className: s.closeButtonWrapper, children: /* @__PURE__ */ c(
          q,
          {
            "aria-label": `Close ${p} Modal`,
            className: s.closeButton,
            "data-testid": "close-button",
            onClick: () => i(!1),
            variant: "ghost",
            children: /* @__PURE__ */ c(M, { size: "md" })
          }
        ) }),
        /* @__PURE__ */ c("div", { className: s.dialogWrapper, children: t })
      ]
    }
  );
}, H = ({ children: t, className: r, ...n }) => /* @__PURE__ */ c("section", { className: W(s.panel, r), ...n, children: /* @__PURE__ */ c("div", { className: s.panelWrapper, children: t }) }), J = j(({ children: t, ...r }, n) => /* @__PURE__ */ c(q, { ref: n, variant: "ghost", ...r, children: t }));
x.Panel = H;
x.Trigger = J;
export {
  x as Dialog
};
